module.exports = __webpack_public_path__ + "static/media/bg_buffalo.db859e92.png";